import { AlertTriangle, Phone, Globe } from "lucide-react";
import Seo from "@/components/Seo";

const RESOURCES = [
  { name: "Emergency (Police / Fire / Ambulance)", phone: "911", note: "Always call 911 first if life is in danger." },
  { name: "988 Suicide & Crisis Lifeline", phone: "988", note: "Call or text 988 — free, confidential, 24/7." },
  { name: "National Domestic Violence Hotline", phone: "1-800-799-7233", web: "https://www.thehotline.org" },
  { name: "SAMHSA — Substance Abuse & Mental Health Helpline", phone: "1-800-662-4357", web: "https://www.samhsa.gov/find-help" },
  { name: "National Human Trafficking Hotline", phone: "1-888-373-7888", web: "https://humantraffickinghotline.org" },
  { name: "Veterans Crisis Line", phone: "988 (then press 1)", web: "https://www.veteranscrisisline.net" },
  { name: "Childhelp National Child Abuse Hotline", phone: "1-800-422-4453", web: "https://www.childhelp.org" },
  { name: "Elder Abuse Hotline (Adult Protective Services)", phone: "1-800-677-1116", web: "https://eldercare.acl.gov" },
];

export default function EmergencyHelp() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <Seo
        title="Emergency help · Jesus Just Us"
        description="If you are in immediate danger, call 911. Trusted hotlines for mental health, abuse, addiction, trafficking, veterans, children, and elder care — staffed 24/7."
        path="/emergency-help"
      />
      <div className="rounded-2xl bg-burgundy text-cream p-6 flex items-start gap-4" data-testid="emergency-banner">
        <AlertTriangle className="h-7 w-7 shrink-0" strokeWidth={1.6} />
        <div>
          <div className="font-serif text-2xl">If you are in immediate danger, call 911.</div>
          <p className="text-sm text-cream/85 mt-2">
            Jesus Just Us is a community platform — not an emergency service. These hotlines are
            staffed by trained professionals available right now.
          </p>
        </div>
      </div>

      <div className="overline text-burgundy mt-12">Emergency help</div>
      <h1 className="font-serif text-4xl text-jjblue mt-2">You are not alone.</h1>
      <p className="mt-3 text-[var(--jj-text-secondary)]">
        Reach out. Someone is waiting to help — confidentially, without judgment, at any hour.
      </p>

      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        {RESOURCES.map((r) => (
          <div key={r.name} className="jj-card p-5" data-testid={`hotline-${r.phone.replace(/\D/g,'')}`}>
            <div className="font-serif text-xl text-jjblue">{r.name}</div>
            <a href={`tel:${r.phone.replace(/[^\d]/g, '')}`} className="mt-3 inline-flex items-center gap-2 text-burgundy font-medium">
              <Phone className="h-4 w-4" strokeWidth={1.6} /> {r.phone}
            </a>
            {r.note && <p className="text-xs text-[var(--jj-muted)] mt-2">{r.note}</p>}
            {r.web && (
              <a href={r.web} target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex items-center gap-1.5 text-xs text-jjblue/80 hover:text-burgundy">
                <Globe className="h-3 w-3" /> Visit website
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
